import { render } from "./PlacedBuilding.vue?vue&type=template&id=15b545c4&scoped=true"
import script from "./PlacedBuilding.vue?vue&type=script&lang=js"
export * from "./PlacedBuilding.vue?vue&type=script&lang=js"

import "./PlacedBuilding.vue?vue&type=style&index=0&id=15b545c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b545c4"]])

export default __exports__